module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Settings-b52b58edd69b20ce5e3680d2ef21c237.svg";